import React from "react"

const englishData = {
    contactUs : "Contact Us",
    faqs : "FAQ's",
    step : 'STEP',
    heading : <>Become the Writer of your <span>Dreams</span></>,
    aboutWriterProgram : {
        heading : 'About Writer Benefit Program',
        subText : <>Writer Benefit Program is our effort to financially reward writers to write <span>Original long-form fiction novels</span> and turn their passion into a career.</>
    },
    journeyCta: 'Start Your Journey',
    revenueAndIncetive:{
        heading: 'Revenue & Incentives',
        tagline: 'UPLOAD DAILY | EARN DAILY',
        note: 'Now open for Hindi & Tamil for Indian Nationals'
    },
    revenueCard: {
        heading: 'Revenue',
        sponsorLine: 'Sponsored by readers 🖤',
        revenueShare: 'Min. 25% Lifetime Revenue Share',
        definition: 'Once your novel is approved for the program, it will be eligible for this reward for lifetime.',
    },
    incentiveCard: {
        heading: 'Incentives',
        sponsorLine: 'Sponsored by us 🖤',
        tagline: <>Earn upto <span>₹1 lakh</span> per book per year</>,
        newNovelBonusCard: {
            heading: 'NEW NOVEL BONUS',
            blueTag: <>Get at least <span>₹3000</span></>
        },
        dailyBonusCard: {
            heading: 'DAILY UPDATE BONUS',
            blueTag: 'Get upto ₹9000/mon.'
        },
        completionBonus: {
            heading: 'COMPLETION BONUS',
            blueTag: <>Get upto <span>₹25,000</span></>
        }
    },
    deadline:{
        heading: 'Deadline to Enter Program',
        text: <>Once part of the program you will be eligible for <br />{' '}
        <span>LIFETIME REVENUE</span></>
    },
    howItWorksLine: "How it Works"
}

const hindiData = {
    contactUs : "संपर्क करें",
    faqs : "लगातार पूछे जाने वाले प्रश्न",
    heading : "लेखक बनने के सपने को करें साकार",
    step : 'चरण',
    aboutWriterProgram : {
        heading : 'राइटर्स बेनिफिट प्रोग्राम के बारे मे',
        subText : 'राइटर बेनिफिट प्रोग्राम के अन्तर्गत हमारा प्रयास है कि लेखकों को आर्थिक रूप से पुरस्कृत किया जाए ताकि वे मूल रूप से काल्पनिक उपन्यास लिखकर अपने जुनून को करियर में बदल सकें।'
    },
    journeyCta: 'अपना सफर शुरू करें',
    revenueAndIncetive:{
        heading: 'पुरस्कार और प्रोत्साहन राशि',
        tagline: 'रोज़ लिखें | रोज़ कमाएँ',
        note: 'केवल हिंदी एवं तमिल उपन्यासों के लिए'
    },
    revenueCard: {
        heading: 'रेवेन्यू ',
        sponsorLine: 'पाठकों द्वारा प्रायोजित 🖤',
        revenueShare: 'न्यूनतम 25% का लाइफटाइम रेवेन्यू शेयर किया जाएगा।',
        definition: 'आपका उपन्यास अगर राइटर बेनिफिट प्रोग्राम के लिए चुना जाता है, तो आप लाईफटाइम इस पुरस्कार के पात्र हो जाएंगे।',
    },
    incentiveCard: {
        heading: 'प्रोत्साहन राशि',
        sponsorLine: 'Pocket Novel द्वारा प्रायोजित 🖤',
        tagline: <>हर एक उपन्यास से लगभग <span>₹1 लाख</span> प्रति वर्ष कमाने का सुनहरा मौका।</>,
        newNovelBonusCard: {
            heading: 'नये उपन्यास का बोनस  प्लान',
            blueTag: <>कम से कम <span>₹3000</span> तक की धनराशि पाएं।</>
        },
        dailyBonusCard: {
            heading: 'रोज़ाना चैप्टर अपडेट बोनस',
            blueTag: <>पाएं <span>₹9000</span> प्रतिमाह तक धनराशि</>
        },
        completionBonus: {
            heading: 'नोवल कम्पलिट करने का बोनस ',
            blueTag: <>पाएं <span>₹25000</span> तक की धनराशि</>
        }
    },
    deadline:{
        heading: 'आवेदन करने की अंतिम तिथि',
        text: <>एक बार प्रोग्राम का हिस्सा बनने के बाद, आप <span> जीवन भर रेवेन्यू </span> के पात्र होंगे।</>,
        spanText: 'LIFETIME REVENUE'
    },
    howItWorksLine: "जाने यह कैसे काम करता है?"
}

const hindiUGCData = {
    contactUs : "संपर्क करें",
    faqs : "लगातार पूछे जाने वाले प्रश्न",
    heading : "लेखक बनने के सपने को करें साकार",
    step : 'चरण',
    aboutWriterProgram : {
        heading : 'राइटर्स बेनिफिट प्रोग्राम के बारे मे',
        subText : 'राइटर बेनिफिट प्रोग्राम के अन्तर्गत हमारा प्रयास है कि लेखकों को आर्थिक रूप से पुरस्कृत किया जाए ताकि वे मूल रूप से ऑडियो सीरीज़ बनाकर अपने जुनून को करियर में बदल सकें।'
    },
    journeyCta: 'अपना सफर शुरू करें',
    revenueAndIncetive:{
        heading: 'पुरस्कार और प्रोत्साहन राशि',
        tagline: 'रोज़ लिखें | रोज़ कमाएँ',
        note: 'केवल हिंदी ऑडियो सीरीज़ के लिए'
    },
    revenueCard: {
        heading: 'रेवेन्यू ',
        sponsorLine: 'पाठकों द्वारा प्रायोजित 🖤',
        revenueShare: 'न्यूनतम 25% का लाइफटाइम रेवेन्यू शेयर किया जाएगा।',
        definition: `आपकी ऑडियो सीरीज़ अगर राइटर बेनिफिट प्रोग्राम में चुनी जाती है, तो आप लाईफटाइम इस पुरस्कार के पात्र हो जाएंगे।`,
    },
    incentiveCard: {
        heading: 'प्रोत्साहन राशि',
        sponsorLine: 'PocketFM द्वारा प्रायोजित 🖤',
        tagline: <>हर एक ऑडियो सीरीज़ से लगभग <span>₹15 लाख</span> प्रति वर्ष कमाने का सुनहरा मौका।</>,
        newNovelBonusCard: {
            heading: 'न्यू सीरीज़ बोनस प्लान',
            blueTag: <>कम से कम <span>₹3000</span> तक की धनराशि पाएं।</>
        },
        dailyBonusCard: {
            heading: 'डेली अपडेट बोनस',
            blueTag: <>पाएं <span>₹9000</span> प्रतिमाह तक धनराशि</>
        },
        completionBonus: {
            heading: 'सीरीज़ कम्पलीशन बोनस',
            blueTag: <>पाएं <span>₹25000</span> तक की धनराशि</>
        }
    },
    deadline:{
        heading: 'आवेदन करने की अंतिम तिथि',
        text: <>एक बार प्रोग्राम का हिस्सा बनने के बाद, आप <span> जीवन भर रेवेन्यू </span> के पात्र होंगे।</>,
        spanText: 'LIFETIME REVENUE'
    },
    howItWorksLine: "जाने यह कैसे काम करता है?"
}

const englishUSData = {
    contactUs : "Contact Us",
    faqs : "FAQ's",
    step : 'STEP',
    heading : <>Stories Amplified: Launch your Audio Series today!</>,
    aboutWriterProgram : {
        heading : 'About Writer Benefit Program',
        subText : <>The Writer Benefit Program is our effort to financially reward writers for writing  <span>Original long-form fiction</span> Audio Series.<br/> With Pocket FM, turn your passion into a career!</>
    },
    journeyCta: 'Start Your Journey',
    revenueAndIncetive:{
        heading: 'Revenue & Incentives',
        tagline: 'UPLOAD DAILY | EARN DAILY',
        note: 'Start your audio series and tell your story to 100mn+ listeners'
    },
    revenueCard: {
        heading: 'Revenue',
        sponsorLine: 'Sponsored by listeners 🖤',
        revenueShare: 'Min 20% Lifetime Revenue Share',
        definition: 'Once your novel is approved for the program, it will be eligible for this reward for lifetime.',
    },
    incentiveCard: {
        heading: 'Incentives',
        sponsorLine: 'Sponsored by Pocket FM 🖤',
        tagline: <></>,
        newNovelBonusCard: {
            heading: 'NEW SERIES BONUS',
            blueTag: <>Guaranteed Min <span>$75</span></>
        },
        dailyBonusCard: {
            heading: 'DAILY UPDATE BONUS',
            blueTag: <>Get up to <span>$375/month</span></>
        },
        completionBonus: {
            heading: 'COMPLETION BONUS',
            blueTag: <>Get upto <span> $650</span></>
        }
    },
    deadline:{
        heading: 'Deadline to Enter Program',
        text: <>Once part of the program you will be eligible for <br />{' '}
        <span>LIFETIME REVENUE</span></>
    },
    howItWorksLine: "How it Works"
}


export { hindiData, englishData, englishUSData, hindiUGCData }